export const HeaderKey_Origin = 'Origin';
export const HeaderKey_Authorization = 'Authorization';
export const HeaderKey_TabId = 'tab-id';
export const HeaderKey_DeviceId = 'device-id';
export const HeaderKey_Application = 'x-application';
export const HeaderKey_Email = 'x-email';
export const HeaderKey_ContentType = 'Content-Type';
export const HeaderKey_AcceptEncoding = 'Accept-Encoding';
export const HeaderKey_ContentEncoding = 'Content-Encoding';
export const ResponseHeaderKey_JWTToken = 'X-Auth-Token';
//# sourceMappingURL=headers.js.map